import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const DocumentSectionSimpleFileSchema = z.object({
  url: z.string().optional().nullable(),
  filename: z.string().optional().nullable(),
  name: z.string().optional().nullable()
});
const DocumentSectionSimpleTopSchema = z.object({
  title: z.string().optional().nullable(),
  files: DocumentSectionSimpleFileSchema.array().optional().nullable()
});
const DocumentSectionSimpleBottomSchema = z.object({
  title: z.string().optional().nullable(),
  text: z.string().optional().nullable(),
  downloadButton: z.object({
    link: z.string().optional().nullable(),
    target: z.string().optional().nullable(),
    download: z.boolean().optional().nullable(),
    text: z.string().optional().nullable(),
    version: z.string().optional().nullable()
  }).optional().nullable(),
  icons: z.array(z.string()).optional().nullable()
});
const DocumentSectionSimpleSchema = z.object({
  id: z.string().optional().nullable(),
  top: DocumentSectionSimpleTopSchema.optional().nullable(),
  bottom: DocumentSectionSimpleBottomSchema.optional().nullable()
}).merge(SectionSpacingSchema);
export default DocumentSectionSimpleSchema;
